import { Injectable } from '@angular/core';
import { NotificationsService } from '../../../common/services/notifications/notifications.service';

@Injectable({
  providedIn: 'root',
})
export abstract class OclNotificationsService extends NotificationsService {}
